import { INSIGHTS_BILL_USAGE_ACTIONS } from '../../actions/insightsBillUsageActions';
import { GRAPH_STYLE, TIMESCALE } from '../../constants/common';

let defaultState = {
    options: {},
    mode: TIMESCALE.YEAR,
    usageGraphStyle: GRAPH_STYLE.COLUMN,
    filterDropdownEl: null,
    switchGasElectric: 'electric',
    switchCostEnergy: 'cost',
    showWeather: true,
    dataNACost: [],
    dataNAEnergy: [],
    dataOngoingCost: [],
    dataOngoingEnergy: [],
    dataTemperature: [],
    dataXAxis: [],
    dataBillingCycleDuration: [],
    dataTimeStampsYear: [],
    dataTimeStampsMonth: [],
    dataTimeStampsDay: [],
    dataTimeStampsHour: [],
    insightsUsageHighChartsData: [],
    dataMonthStart: 0,
    dataMonthEnd: 0,
    dataMonthCost: [],
    dataMonthEnergy: [],
    dataDayStart: 0,
    dataDayEnd: 0,
    dataDayCost: [],
    dataDayEnergy: [],
    dataHourStart: 0,
    dataHourEnd: 0,
    dataHourCost: [],
    dataHourEnergy: [],
    datasYearIndexOffset: 0,
    datasHourIndexOffset: 0,
    datasMonthIndex: null,
    insightsDataLeftArrowDisabled: false,
    insightsDataRightArrowDisabled: true,
    currentBillingCycleInfo: '',
    isUsageChartLoading: true,
    apiErrorMessage: '',
    dataNotAvailableText: '',
    dataEmptyText: '',
    hasOngoingBillingCycle: false,
    hasMissingIntervals: false,
    hasItemizationUnavailable: false,
    showOngoingDisclaimer: false,
    showItemizationUnavailableDisclaimer: false,
    showDataNotAvailableDisclaimer: false,
    isWeekend: [],
    showCostConsumptionToggle: true,
    isPollingHourData: true,
    isDayToHourEvent: false,
    storeDayDataforHour: {} ,
    isStoreHourEnd: true,
    previousHourEnd: 0,
    totalHourData: []
};

const insightsBillAnalysisReducer = (state = Object.assign({}, defaultState), action) => {
    switch (action.type) {
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_BILL_API_ERROR:
            state = {
                ...state,
                apiErrorMessage: 'Some unexpected error occured. Please try again in some time.',
                isUsageChartLoading: false
            }
            break;
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_BILL_DATA_NOT_AVAILABLE:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_YEAR_DATA:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_MONTH_DATA:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_DAY_DATA:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_HOUR_DATA:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_BILLING_CYCLE_PERIOD:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_MODE:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_POLLING:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_GRAPH_STYLE:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_FILTER_DROPDOWN:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_GAS_ELECTRIC:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_COST_ENERGY:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_WEATHER:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_HIGHCHARTS_DATA:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_YEAR_OFFSET:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_MONTH_OFFSET:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_DAY_OFFSET:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_HOUR_OFFSET:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_ARROW_DISABLED:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_FETCH_MONTH_FROM_YEAR:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_FETCH_DAY_FROM_MONTH:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_FETCH_HOUR_FROM_DAY:
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_UPDATE_HIGHCHARTS_OBJECT:
        case INSIGHTS_BILL_USAGE_ACTIONS.SET_DISCLAIMERS_VISIBILITY:
        case INSIGHTS_BILL_USAGE_ACTIONS.SET_PROPS_FOR_COST_CONSUMPTION_TOGGLE:
            state = {
                ...state,
                apiErrorMessage: '',
                ...action.payload
            }
            break;
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_ONGOING_BILLING_CYCLE_DISCLAIMER:
            state = {
                ...state,
                hasOngoingBillingCycle: true,
                usageChartEvent: 'setDisclaimer'
            };
            break;
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_ITEMIZATION_UNAVAILABLE_DISCLAIMER:
            state = {
                ...state,
                hasItemizationUnavailable: true,
                usageChartEvent: 'setDisclaimer'
            };
            break;
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_MISSING_INTERVAL_DISCLAIMER:
            state = {
                ...state,
                hasMissingIntervals: true,
                usageChartEvent: 'setDisclaimer'
            };
            break;
        case INSIGHTS_BILL_USAGE_ACTIONS.USAGE_REMOVE_DISCLAIMERS:
            state = {
                ...state,
                hasOngoingBillingCycle: false,
                hasItemizationUnavailable: false,
                hasMissingIntervals: false,
                usageChartEvent: 'resetDisclaimer'
            };
            break;
        case INSIGHTS_BILL_USAGE_ACTIONS.RESET_DATA:
            state = Object.assign({}, defaultState);
            break;
        default:
            break;
    }
    return state;
}

export default insightsBillAnalysisReducer;